import { render } from "./FollowupDrawer.vue?vue&type=template&id=14262961&scoped=true"
import script from "./FollowupDrawer.vue?vue&type=script&lang=js"
export * from "./FollowupDrawer.vue?vue&type=script&lang=js"

import "./FollowupDrawer.vue?vue&type=style&index=0&id=14262961&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14262961"]])

export default __exports__